import { motion } from 'motion/react';

/**
 * Compact relationship progress badge.
 * @param {{ rpCurrent: number, rpNext: number, tierLabel: string, className?: string, inline?: boolean }} props
 */
export default function RelationshipBadge({ rpCurrent = 0, rpNext = 1, tierLabel = '', className = '', inline = false }) {
  const pct = Math.min(100, Math.round((rpCurrent / Math.max(1, rpNext)) * 100));

  if (inline) {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`}>
        <span className="rounded-md bg-game-accent/20 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-game-accent">
          {tierLabel}
        </span>
        <span className="text-[10px] tabular-nums text-game-muted">{rpCurrent}/{rpNext}</span>
        <span className="inline-block h-1.5 w-10 overflow-hidden rounded-full bg-game-surface">
          <motion.span
            className="block h-full rounded-full bg-gradient-to-r from-game-popup to-game-accent"
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ type: 'spring', damping: 22, stiffness: 140 }}
          />
        </span>
      </span>
    );
  }

  return (
    <div className={`flex items-center gap-2 rounded-xl border border-white/10 bg-game-canvas/90 px-3 py-1.5 shadow-lg backdrop-blur-sm ${className}`}>
      <span className="rounded-md bg-game-accent/20 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-game-accent">
        {tierLabel}
      </span>
      <span className="text-xs tabular-nums text-game-muted">{rpCurrent}/{rpNext}</span>
      <span className="inline-block h-2 w-14 overflow-hidden rounded-full bg-game-surface">
        <motion.span
          className="block h-full rounded-full bg-gradient-to-r from-game-popup to-game-accent"
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ type: 'spring', damping: 22, stiffness: 140 }}
        />
      </span>
    </div>
  );
}
